import { ToolParameter } from '@lumapps/agent-chat-frontend-tools/types';
import { NATIVE_AGENTS } from '@lumapps/agent-hub-agents/constants';
import { LayoutPath } from '@lumapps/widget-layout/types';

export const CONTENT_WRITER_AGENT_ID = NATIVE_AGENTS.pageWriterDesigner.id;
export const PAGE_WRITER_AGENT_ID = NATIVE_AGENTS.pageWriter.id;
export const CONVERSATION_STORE_KEY = 'page-writer-agent.messages';

/** Dedicated feature flag gating the Page Writer agent. */
export const PAGE_WRITER_AGENT_FF = 'page-writer-agent';

/**
 * Metadata list query params shared by the content-settings representation and the publication optimizer's
 * `getAvailableMetadata` tool / suggestion picker, so all three resolve the exact same metadata set
 * (a single React Query cache entry).
 */
export const AGENT_METADATA_LIST_PARAMS = { withInheritance: true, maxResults: '999' } as const;

export const REASON_TOOL_PARAMETER: ToolParameter<string> = {
    type: 'string',
    description: 'Explain the change to the user. This reason will be shown in the UI to the user.',
};

export const PATH_TOOL_PARAMETER: ToolParameter<LayoutPath> = {
    type: 'array',
    items: {
        type: 'string',
    },
    description:
        'The path to the widget in the template (e.g. ["row0", "cell0", "widget0"]). Use getTemplate to find it. Values should respect the pattern: row{number} for rows, cell{number} for cells and widget{number} for widgets.',
};
